import React from 'react'

const KIND_ICONS = {
    pdf: 'fas fa-file-pdf',
    video: 'fas fa-file-video',
    file: 'fas fa-file',
};

function ChatAttachmentPreview({ attachments, onRemove }) {
    if (!attachments || attachments.length === 0) {
        return null;
    }

    return (
        <div className="chat-attachment-preview d-flex flex-wrap justify-content-end">
            {attachments.map((attachment) => (
                <div className="chat-attachment-chip" key={attachment.key}>
                    {attachment.kind === 'image' ? (
                        <img
                            className="chat-attachment-chip__thumb"
                            src={attachment.previewUrl}
                            alt={attachment.name}
                        />
                    ) : (
                        <span className="chat-attachment-chip__thumb chat-attachment-chip__icon">
                            <i className={KIND_ICONS[attachment.kind] || KIND_ICONS.file}></i>
                        </span>
                    )}
                    <span className="chat-attachment-chip__name" title={attachment.name}>
                        {attachment.name}
                    </span>
                    <button
                        type="button"
                        className="chat-attachment-chip__remove"
                        aria-label={__('Remove attachment')}
                        onClick={() => onRemove(attachment.key)}
                    >
                        <i className="fas fa-times-circle"></i>
                    </button>
                </div>
            ))}
        </div>
    );
}

export default ChatAttachmentPreview;
